import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MenuItem } from '../interfaces/menu-item.interface';
import { trackById } from '../../../../utils/track-by';
import icPerson from '@iconify/icons-ic/twotone-person';
import icSettings from '@iconify/icons-ic/twotone-settings';
import icAccountCircle from '@iconify/icons-ic/twotone-account-circle';
import icMoveToInbox from '@iconify/icons-ic/twotone-move-to-inbox';
import icListAlt from '@iconify/icons-ic/twotone-list-alt';
import icTableChart from '@iconify/icons-ic/twotone-table-chart';
import icCheckCircle from '@iconify/icons-ic/twotone-check-circle';
import icAccessTime from '@iconify/icons-ic/twotone-access-time';
import icDoNotDisturb from '@iconify/icons-ic/twotone-do-not-disturb';
import icOfflineBolt from '@iconify/icons-ic/twotone-offline-bolt';
import icChevronRight from '@iconify/icons-ic/twotone-chevron-right';
import icArrowDropDown from '@iconify/icons-ic/twotone-arrow-drop-down';
import icBusiness from '@iconify/icons-ic/twotone-business';
import icVerifiedUser from '@iconify/icons-ic/twotone-verified-user';
import icLock from '@iconify/icons-ic/twotone-lock';
import icNotificationsOff from '@iconify/icons-ic/twotone-notifications-off';
import { Icon } from '@visurel/iconify-angular';
import { PopoverRef } from '../../../../components/popover/popover-ref';
import { UsersService } from './../../../../../app/services/users.service';
import { Router, Event as NavigationEvent } from '@angular/router';
import { BroadcastService } from 'src/app/services/broadcast.service';
import { Message } from 'src/app/interfaces/message.model';
import { LoadingService } from 'src/app/services/loading.service';
import { MatDialog } from '@angular/material/dialog';
import { ChangePasswordComponent } from 'src/app/components/password-management/change-password/change-password.component';



export interface OnlineStatus {
  id: 'online' | 'away' | 'dnd' | 'offline';
  label: string;
  icon: Icon;
  colorClass: string;
}

@Component({
  selector: 'vex-toolbar-user-dropdown',
  templateUrl: './toolbar-user-dropdown.component.html',
  styleUrls: ['./toolbar-user-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarUserDropdownComponent implements OnInit {
  

  session: string = '';
  loginStatus: boolean = false;
  userName: string = '';

  item: MenuItem[] = [
    {
      id: '1',
      icon: icAccountCircle,
      label: 'Change Password',
      description: 'Change Current Password',
      colorClass: 'text-teal',
      route: ''
    },
    // {
    //   id: '2',
    //   icon: icMoveToInbox,
    //   label: 'My Inbox',
    //   description: 'Messages & Latest News',
    //   colorClass: 'text-primary',
    //   route: '/apps/chat'
    // },
    // {
    //   id: '3',
    //   icon: icListAlt,
    //   label: 'My Projects',
    //   description: 'Tasks & Active Projects',
    //   colorClass: 'text-amber',
    //   route: '/apps/scrumboard'
    // },
    // {
    //   id: '4',
    //   icon: icTableChart,
    //   label: 'Billing Information',
    //   description: 'Pricing & Current Plan',
    //   colorClass: 'text-purple',
    //   route: '/pages/pricing'
    // }
  ];

  statuses: OnlineStatus[] = [
    {
      id: 'online',
      label: 'Online',
      icon: icCheckCircle,
      colorClass: 'text-green'
    },
    {
      id: 'away',
      label: 'Away',
      icon: icAccessTime,
      colorClass: 'text-orange'
    },
    {
      id: 'dnd',
      label: 'Do not disturb',
      icon: icDoNotDisturb,
      colorClass: 'text-red'
    },
    {
      id: 'offline',
      label: 'Offline',
      icon: icOfflineBolt,
      colorClass: 'text-gray'
    }
  ];

  activeStatus: OnlineStatus = this.statuses[0];

  trackById = trackById;
  icPerson = icPerson;
  icSettings = icSettings;
  icChevronRight = icChevronRight;
  icArrowDropDown = icArrowDropDown;
  icBusiness = icBusiness;
  icVerifiedUser = icVerifiedUser;
  icLock = icLock;
  icNotificationsOff = icNotificationsOff;

  constructor(private cd: ChangeDetectorRef,
              private popoverRef: PopoverRef<ToolbarUserDropdownComponent>,
              private userService: UsersService,
              private broadcastService:BroadcastService,
              private loadingService: LoadingService,
              private dialog: MatDialog,
              private router: Router
              ) { 

                
              }

  ngOnInit() {
 
    if(localStorage.getItem("user_session_id"))
    {
      this.session = localStorage.getItem("user_session_id")
      this.loginStatus = true;
      this.userName = localStorage.getItem('user_name')
    }

    // console.log(this.session)

  }

  

  setStatus(status: OnlineStatus) {
    this.activeStatus = status;
    this.cd.markForCheck();
  }

  userLogOut()
  {
    // ;
    this.loadingService.showLoader()
    console.log("the logout is clicked")
    this.userService.userSignout(this.session).subscribe(
      (res: Response) => {
        this.loadingService.hideLoader();
        this.userService.removeUserLocalStorage();
        this.session = "";
        localStorage.removeItem('loggedInUserDetails')
        this.loginStatus = false;
        this.popoverRef.close();
        this.router.navigate(['/']);
      },
      (error: any) => {
        console.log(error)
        this.loadingService.hideLoader();
        // if(error.error.error.error_code === "sessionExpired"){
        //   this.userService.removeUserLocalStorage();
        //   this.session = "";
        //   localStorage.removeItem('loggedInUserDetails')
        //   this.loginStatus = false;
        //   this.popoverRef.close();
        //   this.router.navigate(['/']);
        // }
        this.broadcastService.sessionCheck(error)
        
      }
    )

  }

  close()
  {
    console.log("the close is clicked")
  }


  showChangePasswordPopup(){
    let url = location.href;
    this.popoverRef.close();
    this.dialog.open(ChangePasswordComponent, {
      data: {url:url},
      width: 'auto',
      height: 'auto',
      minWidth: '500px'
    }).afterClosed().subscribe(item => {
      console.log(item);
      if(item === 'yes'){
        
        
      }
      
      
    })
  }

  changePassword()
  {
    console.log("the change password")
  }
}
